import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { UtilsService } from '@utils/utils.service';
import {
  Response,
  PagedTableResponse,
  PagedTableRequest,
  QueryRequest,
  CertificateIdsRequest,
  PreloadedCertificate,
  PreloadedCertificateIds,
  PreloadedCertificateActivateRequest,
} from '@models/index.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CertificatesPendingService {
  private UrlAPI = environment.apiUrl;

  constructor(private http: HttpClient, private _utils: UtilsService) {}

  public getPreloadedCertificates(
    preloadedCertsRequest: PagedTableRequest
  ): Observable<Response<PagedTableResponse<PreloadedCertificate>>> {
    const query = this.UrlAPI + QueryRequest.preloadedCertificates;
    return this.http.post<Response<PagedTableResponse<PreloadedCertificate>>>(
      query,
      this._utils.stringifyData(preloadedCertsRequest)
    );
  }

  public getPreloadedCertificateIds(preloadedCertIdsRequest: CertificateIdsRequest): Observable<Response<PreloadedCertificateIds>> {
    const query = this.UrlAPI + QueryRequest.preloadedCertificatesIds;
    return this.http.post<Response<PreloadedCertificateIds>>(query, this._utils.stringifyData(preloadedCertIdsRequest));
  }

  public deletePreloadedCertificate(deletePreloadedCertRequest: PreloadedCertificateIds): Observable<Response<Array<number>>> {
    const query = this.UrlAPI + QueryRequest.preloadCertificate;
    const options = { body: this._utils.stringifyData(deletePreloadedCertRequest) };
    return this.http.delete<Response<Array<number>>>(query, options);
  }

  public activatePreloadedCertificate(activatePreloadedCertRequest: PreloadedCertificateActivateRequest) {
    const query = this.UrlAPI + QueryRequest.preloadCertificateActivate;
    return this.http.put<Response<Array<number>>>(query, this._utils.stringifyData(activatePreloadedCertRequest));
  }
}
